import commonLocalisations from './commonLocalisations'
// import squareStudy from './squareStudy/squareStudyConfig'
import vorsoPilot from './vorsoPilot/vorsoPilotConfig'

export default {
  commonLocalisations: commonLocalisations,
  studies: {
    // 'square-study': squareStudy,
    'vorso-pilot': vorsoPilot
  }
}
